module.exports = __webpack_public_path__ + "img/UTGREA.5230f0fb.png";